import { useHistory, useLocation } from 'react-router-dom'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { getCompanyProfile } from '../services/ApiService'

/** Redux **/
import { authActions } from '../store/signIn'
import { dataActions } from '../store/data'
import { useSelector } from 'react-redux'
import { store } from '../store'

/** Material UI **/
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Typography
} from '@mui/material'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { StyledNavTab, StyledNavTabs } from '../styles/mui_custom_components'

/** Services **/
import { removeAuthorizationHeader } from '../lib/Api'

/** Icons */
import GridIcon from '../assets/icons/grid_icon.svg'

/** Styles */
import { navBarStyles } from '../styles/classes/CommonClasses'

// utils
import { Routes as MainRoutes } from '../lib/Constants'

export const NavBar = () => {
  const { classes } = navBarStyles()
  const userStore = useSelector(state => state.auth.user)
  const location = useLocation()

  const { t } = useTranslation()
  const history = useHistory()

  const [company, setCompany] = useState(null)
  // TODO CHANGING TAB
  const [value, setValue] = useState('/field-forms')
  const [anchorEl, setAnchorEl] = useState()
  const isMenuOpen = Boolean(anchorEl)

  useEffect(() => {
    // set navbar value
    if (
      location.pathname === MainRoutes.SIGN_IN.path ||
      location.pathname === MainRoutes.ROOT.path ||
      location.pathname === MainRoutes.DASHBOARD.path ||
      location.pathname === MainRoutes.FORGOT_PASSWORD.CODE.path
    ) {
      setValue('/field-forms')
      history.push('/field-forms')
    } else {
      setValue(location.pathname)
    }
  }, [location.pathname])

  useEffect(() => {
    initialMethod()
  }, [])

  const initialMethod = async () => {
    try {
      const response = await getCompanyProfile(userStore.userInfo.company_id)
      setCompany(response)
    } catch (error) {
      console.error('Error retrieving company profile: ', error)
    }
  }

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleChangeNavBar = (event, newValue) => {
    history.push(newValue)
  }

  const handleChangeMenu = route => {
    setAnchorEl(null)
    history.push(route)
  }

  const logoutHandler = () => {
    store.dispatch(authActions.logout())
    store.dispatch(dataActions.logout())
    removeAuthorizationHeader()
    history.replace('/')
  }

  return (
    <Box pl={3} pr={3} className={classes.navBar}>
      <Box className={classes.header}>
        <Box display="flex">
          <Box
            className={classes.boxLogo}
            pt={1}
            pr={2}
            display={'inline-flex'}
          >
            <Avatar
              alt="profile"
              src={company?.tech_support?.customer_logo ?? null}
              className={
                company?.tech_support?.customer_logo
                  ? classes.avatar
                  : classes.emptyAvatar
              }
              imgProps={{ style: { objectFit: 'contain' } }}
            >
              <FontAwesomeIcon icon={faBuilding} size="2x" />
            </Avatar>
          </Box>
          <StyledNavTabs
            value={value}
            onChange={handleChangeNavBar}
            aria-label="basic tabs example"
          >
            <StyledNavTab
              style={{ display: 'none' }} // to avoid errors
              value={'/company-settings'}
              label={t('nav_bar.company_settings')}
              iconPosition="end"
            />
            <StyledNavTab
              style={{ display: 'none' }} // to avoid errors
              value={'/account-settings'}
              label={t('nav_bar.company_settings')}
              iconPosition="end"
            />
            <StyledNavTab
              value={'/field-forms'}
              label={t('nav_bar.field_forms')}
              iconPosition="end"
            />
          </StyledNavTabs>
        </Box>
        <Box display="flex">
          {userStore?.userInfo?.company_name && (
            <Typography className={classes.companyName}>
              {userStore.userInfo.company_name}
            </Typography>
          )}
          <IconButton
            className={classes.menu}
            edge="end"
            aria-label="account of current user"
            aria-controls={'men1'}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
            disableRipple
          >
            <img src={GridIcon} className={classes.menuIcon} alt="menu icon" />
          </IconButton>
          <Menu
            id={'men1'}
            open={isMenuOpen}
            onClose={handleMenuClose}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <MenuItem
              style={{ display: 'none' }}
              className={classes.menuItem}
              value={'/manage-account'}
            >
              {t('nav_bar.manage_account')}
            </MenuItem>
            <MenuItem
              className={classes.menuItem}
              onClick={() => handleChangeMenu('/account-settings')}
            >
              {t('nav_bar.account_settings')}
            </MenuItem>
            <MenuItem
              className={classes.menuItem}
              onClick={() => handleChangeMenu('/company-settings')}
            >
              {t('nav_bar.company_settings')}
            </MenuItem>
            <MenuItem
              style={{ display: 'none' }}
              className={classes.menuItem}
              value={'/help'}
            >
              {t('nav_bar.help')}
            </MenuItem>
            <MenuItem
              style={{ display: 'none' }}
              className={classes.menuItem}
              value={'/send-feedback'}
            >
              {t('nav_bar.send_feedback')}
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={logoutHandler}>
              {t('nav_bar.log_out')}
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  )
}
